import dayjs from "dayjs";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";

// STATISTICS_xxxx-xx-xx
const defaultTitle = 'STATISTICS_' + dayjs().startOf('day').format('YYYY-MM-DD')
export const htmlToExcel = (dom, title = defaultTitle) => {
    // console.log('dom', document.querySelector(dom), XLSX);
    var excelTitle = title;
    var wb = XLSX.utils.table_to_book(document.querySelector(dom), { raw: true });
    /* 获取二进制字符串作为输出 */
    var wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
    try {
        FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            excelTitle + ".xlsx"
        );
    } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
    }
    return wbout;
};